import { render, staticRenderFns } from "./CompetitionRules.vue?vue&type=template&id=45efd01e&scoped=true&lang=html&"
import script from "./CompetitionRules.vue?vue&type=script&lang=js&"
export * from "./CompetitionRules.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionRules.vue?vue&type=style&index=0&id=45efd01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45efd01e",
  null
  
)

export default component.exports